import React from 'react';
import '../scss/AboutUs.scss';

const AboutUs: React.FC = () => {
  return (
    <section className="about-us" id="aboutUs">
      <div className="about-us__image">
        <img src="/aboutoss.jpg" alt="Om oss" />
      </div>
      <div className="about-us__text">
        <h2>Om oss</h2>
        <p>
       Vi på Accordi är specialiserade på italienska delikatesser av högsta kvalitet. Vår passion för genuina råvaror och traditionella tillverkningsmetoder driver oss att erbjuda endast det bästa till restauranger, caféer och livsmedelsbutiker över hela landet.

        Med lång erfarenhet inom branschen och nära samarbeten med noggrant utvalda producenter i Italien och Europa, säkerställer vi att varje produkt vi levererar håller högsta standard – från smak till hållbarhet. Vi vet att kvalitet och äkthet är avgörande för våra kunders verksamheter och deras slutkunders upplevelse.

        Vårt mål är att vara en pålitlig partner som inte bara levererar produkter, utan också kunskap och inspiration. Genom att förstå våra kunders behov hjälper vi dem att utveckla menyer och sortiment som sticker ut, och vi arbetar ständigt för att erbjuda nya spännande produkter och lösningar.

        Accordi är mer än en grossist – vi är en del av ditt kvalitetsarbete och din framgång.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
